// rename-giftwrap.js
document.addEventListener('DOMContentLoaded', () => {
  // Select all cart item properties
  const propertyElements = document.querySelectorAll('.cart-items__properties dd');

  propertyElements.forEach((el) => {
    const labelEl = el.previousElementSibling; // dt element
    if (labelEl && labelEl.textContent.trim() === 'GiftWrap:') {
      labelEl.textContent = 'Certificate of Authenticity:';
    }
  });
});